var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"cover"},[_c('iain-image-domain',{attrs:{"w":"66","h":"66","r":"10","src":item.icon}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }